import { useEffect, useState, useCallback } from 'react'
import { useMutationObserver } from '@fs/zion-frontend-friends'

const adjustHeight = (element) => {
  if (element && element.style.getPropertyValue('--layout-viewport-height') !== '100%') {
    element.style.setProperty('--layout-viewport-height', '100%')
  }
}

export default function useHeightAdjustment(appElement) {
  const [observedElement, setObservedElement] = useState(null)

  // This callback is used to find the elements that need their height adjusted
  // does an initial adjustment and then is disabled
  const searchCallback = useCallback(() => {
    if (appElement.current !== null) {
      const element = appElement.current.querySelector('[style*="--layout-viewport-height"]')
      if (element) {
        adjustHeight(element)
        setObservedElement(element)
      }
    }
  }, [appElement])

  // Watch for ALL changes to the element
  // disabled after finding the element that needs adjustment
  useMutationObserver(appElement, searchCallback, appElement.current !== null && !observedElement, {
    attributeFilter: ['style'], // --layout-viewport-height is set in style tag
    childList: true,
    subtree: true,
  })

  // Using `useMutationObserver` to watch for these changes wasn't respecting the change in config from the original
  useEffect(() => {
    let observer

    if (observedElement) {
      observer = new window.MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          adjustHeight(mutation.target)
        })
      })
      observer.observe(observedElement, {
        attributeFilter: ['style'],
        // at this point we only need to watch this element
        childList: false,
        subtree: false,
      })
    }

    return () => {
      observer?.disconnect()
    }
  }, [observedElement])
}
